export default __webpack_public_path__ + "static/media/Timeline.9f061512.svg";